<div class="year-picker">
  <div class="date-header">{{ headerName }}</div>

  <!-- Year Navigation -->
  <div class="year-nav"> 
    <button mat-icon-button class="nav-button prev" (click)="moveStartYearPrevious()" aria-label="Previous year">
    </button>
    <span>{{ startrangeYear }} - {{ startrangeYear + 11 }}</span>
    <button mat-icon-button class="nav-button next" (click)="moveStartYearNext()" aria-label="Next year">
    </button>
  </div>

  <!-- Year Selection -->
  <div class="year-picker-years">
    <button *ngFor="let year of years" 
            class="year-picker-button"
            [class.selected]="isYearSelected(year)"
            [class.in-range]="isYearInRange(year)"
            [class.disabled]="isYearDisabled(year)"
            (click)="selectYear(year)">
      {{ year }}
    </button>
  </div>

  <!-- Date Inputs -->
  <div class="date-inputs">
    <div class="input-group">
      <span class="input-group-text" style="padding: 6px 9px;">Start Date</span>
      <input type="text" class="form-control" [value]="startYear ? (getYearStartDate(startYear) | date:'MM.dd.yyyy') : ''" readonly />
    </div>
    <div class="input-group">
      <span class="input-group-text">End Date</span>
      <input type="text" class="form-control" [value]="endYear ? (getYearEndDate(endYear) | date:'MM.dd.yyyy') : ''" readonly />
    </div>
  </div>

  <!-- Actions -->
  <div class="actions">
    <button matTooltip="Clear Selection" class="btn clear" (click)="clearSelection()">Clear</button>
    <button matTooltip="Apply Selection" class="btn apply"  cdkMenu [disabled]="!startYear || !endYear" (click)="applyDates()">Apply</button>
  </div>
</div>
